import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";

const StyledCard = styled(Card)`
  &.MuiCard-root {
    padding: 14px;
  }
  ,
  &.MuiPaper-elevation1 {
    box-shadow: 0 7px 30px -10px rgba(150, 170, 180, 0.5);
  }
  ,
`;

const StyledCardContent = styled(CardContent)`
  &.MuiCardContent-root {
    padding: 14px;
  }
`;

export { StyledCard, StyledCardContent };
